// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2yrG1","modalForm":"UpgradeEpcsModal_modalForm__1qSf9","modalFooter":"UpgradeEpcsModal_modalFooter__GgNj0"};